import { cn } from "@/shared/libs/commonUtils";
import { useCarousel } from "./CarouselContext";
import type { HTMLAttributes, Ref } from "react";

interface ICarouselItemProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export default function CarouselItem({
  ref,
  className,
  ...props
}: ICarouselItemProps) {
  const { orientation } = useCarousel();
  return (
    <div
      ref={ref}
      role="group"
      aria-roledescription="slide"
      className={cn(
        "min-w-0 shrink-0 grow-0 basis-full",
        orientation === "horizontal" ? "pl-4" : "pt-4",
        className,
      )}
      {...props}
    />
  );
}
